<nz-form-item class="!mb-0">

  <nz-form-control
    [nzValidateStatus]="ngControl.control ?? ''"
    [nzErrorTip]="errorTpl"
    [nzExtra]="helperTpl"
  >

    <div class="input-wrapper" [class]="{'has-icon': isLockable, 'locked': isLocked}">

      <input
        nz-input
        [type]="type"
        [disabled]="disabled"
        [readOnly]="isLocked"
        [attr.min]="min || null"
        [attr.max]="max || null"
        [value]="value"
        (input)="onInput($event)"
        (focus)="onFocus()"
        (blur)="handleBlur()"
        [placeholder]="placeholder || ''"
        [attr.maxlength]="maxlength ?? null"
        [attr.minlength]="minlength ?? null"
      />
      <label *ngIf="label">
        {{ label }}
      </label>

      <!-- Lock Button -->
      <button
        nz-button
        nzType="link"
        type="button"
        *ngIf="isLockable"
        (click)="toggleLock()"
        tabindex="-1">
      <fa-icon [icon]="isLocked ? icons.falPen : icons.falPenSlash " ></fa-icon>
      </button>

    </div>

  </nz-form-control>
</nz-form-item>

<ng-template #errorTpl>
  <ng-container *ngIf="showError">
    <span *ngIf="firstErrorKey">
      {{ errorMessages[firstErrorKey] || firstErrorKey }}
    </span>
  </ng-container>
</ng-template>

<ng-template #helperTpl>
  <span *ngIf="showHelper">
    {{ helperText }}
  </span>
</ng-template>
